import { ICommonsService } from './../services/commons_service';
import { FuncionarioDropDown } from "../../domain/models/funcionario_dropdown";
import { ICommonsRepository } from "../../domain/repositories/commons_repository";
import { LogAlteracao } from "../../domain/models/log_alteracao";
import { Paginated } from "../../domain/models/paginated_models";
import { GEDDocumento } from '../../domain/models/ged_documento';
import { DropDown } from '../../domain/models/dropdown';
import { UsuarioDropDown } from '../../domain/models/usuario_dropdown';
import { CargoDropDown } from '../../domain/models/cargo_dropdown';
import { FornecedorDropDown } from '../../domain/models/fornecedor_dropdown';
import { CentroCustoDropDown } from '../../domain/models/centro_custo_dropdown';
import { ClienteSimplificadoForm } from '../../presentation/schemas/ClienteSimplificado';
import { SubcontaSimplificadoForm } from '../../presentation/schemas/SubContaSimplificado';
import { NomeAuditorDropDown } from '../../domain/models/nome_auditor_dropdown';
import { FuncionarioInformation } from '../../domain/models/funcionario_information';
import { DataAuditoriaDropDown } from '../../domain/models/data_auditoria_dropdown';
import { DataCronogramaSGQDropDown } from '../../domain/models/data_cronogramaSGQ__dropdown';
import { FuncionarioTercDropDown } from '../../domain/models/funcionario_terc_dropdown';
import { DataProvisaoRecursoDropDown } from '../../domain/models/data_provisao_recurso_dropdow';
import { ProdutoServicoDropDown } from '../../domain/models/produto_servico_dropdown';
import { ContratoDropDown } from '../../domain/models/contrato_dropdown';
import { RequisicaoCompraDropDown } from '../../domain/models/requisicao_compra_dropdown';
import { AtributoCompra } from '../../domain/models/atributo_compra';
import { ColetaPrecoDropDown } from '../../domain/models/coleta_preco_dropdown';
import { DropDownUnidade } from '../../domain/models/dropdownUnidade';
import { ClienteDropDown } from '../../domain/models/cliente_dropdown';
import { ClienteCentroCustoDropDown } from '../../domain/models/cliente_centro_custo_dropdown';
import { PrincipalDocumentosLista } from '../../../features/auditoria/domain/models/documentos_lista';
import { DropDownProdutoServicoDto } from '../../domain/models/dropdown_produto_servico';
import { FornecedorDadosCnpj } from '../../domain/models/fornecedor_dados_cnpj';
import { JobStatusResponse } from '../../domain/models/job_status_response';

/**
 * CommonsRepository
 */

export class CommonsRepository implements ICommonsRepository {
  constructor(
    private readonly service: ICommonsService,
  ) { }

  async getJobStatus(operacaoId: string): Promise<JobStatusResponse> {
    return this.service.getJobStatus({ operacaoId });
  }

  async getCentroCustoDropDown(IdContrato?: number | null): Promise<DropDown[]> {
    const response = await this.service.getCentroCustoDropDown({ IdContrato });
    return [...response.itens.map((i) => ({
      id: i.idCentroCusto,
      title: `${i.codigo} - ${i.descricao}`,
    }))];
  }

  async getCentroCustoEmpreendimentoDropDown(idEmpreendimento?: number | null): Promise<DropDown[]> {
    const response = await this.service.getCentroCustoEmpreendimentoDropDown(idEmpreendimento);
    return [...response.itens.map((i) => ({
      id: i.idCentroCusto,
      title: `${i.codigo} - ${i.descricao}`,
    }))];
  }

  async getIndicadoresDropDown(): Promise<DropDown[]> {
    const response = await this.service.getIndicadoresDropDown();
    return response.itens.map(item => ({
      id: item.idIndicador,
      title: item.descricao,
    }));
  }

  async getReportEntregaObraGeralDropDown(idEntregaObra: number, tipo: string): Promise<DropDown[]> {
    switch (tipo) {
      case 'cliente':
        return await this.service.getReportDropDownEntregaObraCliente(idEntregaObra);
      case 'unidade':
        return await this.service.getReportDropDownEntregaObraUnidade(idEntregaObra);
      case 'checklist':
        return await this.service.getReportDropDownEntregaObraChecklist(idEntregaObra);
      case 'localVistoria':
        return await this.service.getReportDropDownEntregaObraLocal(idEntregaObra);
      default:
        return [];
    }
  }

  async getMedicaoTerceirizacaoDropDown(): Promise<DropDown[]> {
    const response = await this.service.getMedicaoTerceirizacaoDropDown()
    return response;

  }

  async getProdutoServicoDropDown(tipo: string | undefined): Promise<DropDownProdutoServicoDto[]> {
    const response = await this.service.getProdutoServicoDropDown(tipo ?? 'A');
    return response;
  }

  async getClientesDropDown(
    idCentroCusto?: number | null
  ): Promise<ClienteDropDown[]> {
    const response = await this.service.getClienteDropDown({ idCentroCusto });
    return [...response.items.map((i) => ({
      id: i.id,
      title: i.descricao,
    }))];
  }

  async getListSimpleDropDown(): Promise<CentroCustoDropDown[]> {
    const response = await this.service.getCentroCustoDropDown({ IdContrato: 0 });
    return [...response.itens.map((i) => ({
      id: i.idCentroCusto,
      title: `${i.codigo} - ${i.descricao}`,
    }))];
  }

  async getCargosDropDown(): Promise<CargoDropDown[]> {
    const response = await this.service.getCargosDropDown();
    return [...response.itens.map((i) => ({
      idCargo: i.idCargo,
      descricao: i.descricao ?? "",
    }))];
  }

  async getBancosPagamentoDropDown(): Promise<DropDown[]> {
    const response = await this.service.getBancosPagamentoDropDown();
    return [...response.items.map((i) => ({
      id: i.idBancoPagamento,
      title: i.descricao,
    }))];
  }

  async getSubcontasDropDown(): Promise<DropDown[]> {
    const response = await this.service.getSubcontasDropDown();
    return [...response.items.map((i) => ({
      id: i.idSubconta,
      title: i.descricao,
    }))];
  }

  async getOrdemComprasDropDown(): Promise<DropDown[]> {
    const response = await this.service.getOrdemComprasDropDown({});
    return response.itens;
  }

  async getColetaPrecoDropDown(): Promise<ColetaPrecoDropDown[]> {
    const response = await this.service.getColetaPrecoDropDown({});
    return response.itens;
  }

  async getClienteCentroCustoDropDown(): Promise<ClienteCentroCustoDropDown[]> {
    const response = await this.service.getClienteCentroCustoDropDown({});
    return response.itens;
  }

  async getProjetosDropDown(idCentroCusto?: number): Promise<DropDown[]> {
    const response = await this.service.getProjetosDropDown({ idCentroCusto });
    return response.itens;

  }

  async getFuncionariosDropDown(
    filtrarCentroCusto?: boolean,
    includeCantBeSelected?: boolean,
    somenteComBiometria?: boolean,
    idCargo?: number,
  ): Promise<FuncionarioDropDown[]> {
    const response = await this.service.getFuncionariosDropDown({
      filtrarCentroCusto: filtrarCentroCusto ?? false,
      includeCantBeSelected: includeCantBeSelected ?? false,
      somenteComBiometria: somenteComBiometria ?? undefined,
      idCargo: idCargo ?? 0
    });
    return [...response.itens];
  }

  async getUsuarioDropDown(): Promise<UsuarioDropDown[]> {
    const response = await this.service.getUsuarioDropDown();
    return [...response.itens.map((i) => ({
      idUsuario: i.idUsuario,
      nome: i.nome,
    }))];
  }

  async getChecklistEntregaObraDropDown(): Promise<DropDown[]> {
    const response = await this.service.getChecklistEntregaObraDropDown();
    return response;

  }

  async getEmpreendimentoDropDown(idObra?: number | null): Promise<DropDown[]> {
    const response = await this.service.getEmpreendimentoDropDown(idObra);
    return response;
  }

  async getTermosDropDown(): Promise<DropDown[]> {
    const response = await this.service.getTermosDropDown();
    return response;
  }

  async getUnidadesDropDown(): Promise<DropDownUnidade[]> {
    const response = await this.service.getUnidadesDropDown({});
    return [...response.itens.map((i) => ({
      id: i.id,
      idCliente: i.idCliente,
      idCentroCusto: i.idCentroCusto,
      title: i.title,
    }))];

  }

  async getContratosFinanceiroDropDown(idIndiceReajuste: number | null): Promise<DropDown[]> {
    const response = await this.service.getContratosFinanceiroDropDown({ idIndiceReajuste });
    return [...response.items.map((i) => ({
      id: i.id,
      title: i.title,
    }))];
  }


  async getPageSize(idPage: number): Promise<number> {
    const response = await this.service.getPageSize({ idPage });
    return response.size;
  }

  async getAllLogAlteracao(
    tipoTabela: number,
    idTabela: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<LogAlteracao>> {
    return await this.service.getAllLogAlteracao({ tipoTabela, idTabela, page, rowsPerPage });
  }

  async getAllLogAlteracaoByParent(
    tipoTabelaPai: number,
    idTabelaPai: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<LogAlteracao>> {
    return await this.service.getAllLogAlteracaoByParent({ tipoTabelaPai, idTabelaPai, page, rowsPerPage });
  }

  async getFuncionariosByIdCentroCustoDropDown(
    idCentroCusto: number,
    includeSecondary: boolean | null,
  ): Promise<FuncionarioDropDown[]> {
    const response = await this.service.getFuncionariosByIdCentroCustoDropDown({
      idCentroCusto,
      includeSecondary,
    });
    return response.items;
  }

  async getFornecedorDropDown(
    filtrarCentroCusto: boolean,
    FornServico?: boolean
  ): Promise<FornecedorDropDown[]> {
    const response = await this.service.getFornecedorDropDown({ filtrarCentroCusto, FornServico });
    return response.itens;
  }

  async getNomeAuditorDropDown(): Promise<NomeAuditorDropDown[]> {
    const response = await this.service.getNomeAuditorDropDown({});
    return response.itens;
  }

  async getDataAuditoriaDropDown(): Promise<DataAuditoriaDropDown[]> {
    const response = await this.service.getDataAuditoriaDropDown({});
    return response.itens;
  }
  async getDataCronogramaSGQDropDown(Tipo: "DataPrevista" | "DataRealizada"): Promise<DataCronogramaSGQDropDown[]> {
    const response = await this.service.getDataCronogramaSGQDropDown({ Tipo });
    return response.itens;
  }
  async getDataProvisaoRecursoDropDown(): Promise<DataProvisaoRecursoDropDown[]> {
    const response = await this.service.getDataProvisaoRecursoDropDown({});
    return response.itens;
  }


  async getFuncionariosTercDropDown(
    filtrarCentroCusto: boolean | null,
    idFornecedor?: number
  ): Promise<FuncionarioTercDropDown[]> {
    const response = await this.service.getFuncionariosTercDropDown({ filtrarCentroCusto, idFornecedor });
    return response.itens;
  }

  async getAllGedDocumento(
    telaId: number,
    idModuloDocumento: number | null,
    tipoPesquisa: number | null,
    valueField: string | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<GEDDocumento>> {
    return await this.service.getAllGedDocumento({
      telaId,
      idModuloDocumento,
      tipoPesquisa,
      valueField,
      status,
      page,
      rowsPerPage,
    });
  }

  async createGedDocumento(
    idTela: number,
    idModuloDocumento: number,
    statusArquivo: number | null,
    tipo: number | null,
    arquivo: string,
    versao: string | null,
    centroCusto: number | null,
    revisadoPor: number | null,
    aprovadoPor: number | null,
    responsavelProcesso: number | null,
    localArmazenamento1: string | null,
    localArmazenamento2: string | null,
    acesso: string | null,
    recuperacao: string | null,
    protecao: string | null,
    retencao: string | null,
    disposicao: string | null,
    observacoes: string | null,
    assunto: string | null,
    conferirAtualizacao: Date | null,
    ondeConsultar: string | null,
    dataVencimento: Date | null,
    dataPublicacao: Date | null,
    dataVigencia: Date | null,
    filedata: File | null,
    filedataPdf: File | null,
    revisao: number | null,
  ): Promise<void> {
    await this.service.createGedDocumento({
      idTela,
      idModuloDocumento,
      statusArquivo,
      tipo,
      arquivo,
      versao,
      centroCusto,
      revisadoPor,
      aprovadoPor,
      responsavelProcesso,
      localArmazenamento1,
      localArmazenamento2,
      acesso,
      recuperacao,
      protecao,
      retencao,
      disposicao,
      observacoes,
      assunto,
      conferirAtualizacao,
      ondeConsultar,
      dataVencimento,
      dataPublicacao,
      dataVigencia,
      filedata,
      filedataPdf,
      revisao
    });
  }

  async updateGedDocumento(
    idTela: number,
    idGedDocumento: number,
    statusArquivo: number | null,
    tipo: number | null,
    arquivo: string,
    versao: string | null,
    centroCusto: number | null,
    revisadoPor: number | null,
    aprovadoPor: number | null,
    responsavelProcesso: number | null,
    localArmazenamento1: string | null,
    localArmazenamento2: string | null,
    acesso: string | null,
    recuperacao: string | null,
    protecao: string | null,
    retencao: string | null,
    disposicao: string | null,
    observacoes: string | null,
    assunto: string | null,
    conferirAtualizacao: Date | null,
    ondeConsultar: string | null,
    dataVencimento: Date | null,
    dataPublicacao: Date | null,
    dataVigencia: Date | null,
    filedata: File | null,
    filedataPdf: File | null,
    cleanFile: boolean,
    cleanFilePdf: boolean,
    revisao: number | null
  ): Promise<void> {
    await this.service.updateGedDocumento({
      idTela,
      idGedDocumento,
      statusArquivo,
      tipo,
      arquivo,
      versao,
      centroCusto,
      revisadoPor,
      aprovadoPor,
      responsavelProcesso,
      localArmazenamento1,
      localArmazenamento2,
      acesso,
      recuperacao,
      protecao,
      retencao,
      disposicao,
      observacoes,
      assunto,
      conferirAtualizacao,
      ondeConsultar,
      dataVencimento,
      dataPublicacao,
      dataVigencia,
      filedata,
      filedataPdf,
      cleanFile,
      cleanFilePdf,
      revisao
    });
  }

  async deleteGedDocumento(
    idTela: number,
    idGedDocumento: number,
  ): Promise<void> {
    await this.service.deleteGedDocumento({
      idTela,
      idGedDocumento,
    });
  }

  async copyGedDocumento(
    idTela: number,
    idGedDocumento: number,
    statusArquivo: number | null,
    tipo: number | null,
    arquivo: string,
    versao: string | null,
    centroCusto: number | null,
    revisadoPor: number | null,
    aprovadoPor: number | null,
    responsavelProcesso: number | null,
    localArmazenamento1: string | null,
    localArmazenamento2: string | null,
    acesso: string | null,
    recuperacao: string | null,
    protecao: string | null,
    retencao: string | null,
    disposicao: string | null,
    observacoes: string | null,
    assunto: string | null,
    conferirAtualizacao: Date | null,
    ondeConsultar: string | null,
    dataVencimento: Date | null,
    dataPublicacao: Date | null,
    dataVigencia: Date | null,
    filedata: File | null,
    filedataPdf: File | null,
    cleanFile: boolean,
    cleanFilePdf: boolean,
  ): Promise<void> {
    await this.service.copyGedDocumento({
      idTela,
      idGedDocumento,
      statusArquivo,
      tipo,
      arquivo,
      versao,
      centroCusto,
      revisadoPor,
      aprovadoPor,
      responsavelProcesso,
      localArmazenamento1,
      localArmazenamento2,
      acesso,
      recuperacao,
      protecao,
      retencao,
      disposicao,
      observacoes,
      assunto,
      conferirAtualizacao,
      ondeConsultar,
      dataVencimento,
      dataPublicacao,
      dataVigencia,
      filedata,
      filedataPdf,
      cleanFile,
      cleanFilePdf,
    });
  }

  async createClienteSimplificado(form: ClienteSimplificadoForm): Promise<number> {
    const response = await this.service.createClienteSimplificado({ ...form });
    return response.id;
  }

  async createSubcontaSimplificado(form: SubcontaSimplificadoForm): Promise<number> {
    const response = await this.service.createSubcontaSimplificado(
      {
        ...form,
        ativo: form.ativo === 1 ? true : false,
      });
    return response.id;
  }

  async getFuncionarioByIdUsuario(
    idUsuario: number,
  ): Promise<FuncionarioInformation | null> {
    const response = await this.service.getFuncionarioByIdUsuario({
      idUsuario,
    });
    return response.item;
  }

  async getFornecedorDadosByCnpj(
    cnpj: string,
  ): Promise<FornecedorDadosCnpj> {
    return await this.service.getFornecedorDadosByCnpj({ cnpj });
  }

  async getEquipamentosDropDown(): Promise<DropDown[]> {
    const response = await this.service.getEquipamentosDropDown();
    return response.itens.map(item => ({
      id: item.idMaquinaEquip,
      title: item.descricao,
    }));
  }

  async getProdutosServicosDropDown(
    filtrarTipo: string | null,
    incluirIdProdutoServico: number | null,
    incluirCodigoDescricao: boolean | null,
  ): Promise<ProdutoServicoDropDown[]> {
    const response = await this.service.getProdutosServicosDropDown({
      filtrarTipo,
      incluirIdProdutoServico,
      incluirCodigoDescricao,
    });
    return response.itens;
  }
  async getContratoDropDown(): Promise<ContratoDropDown[]> {
    const response = await this.service.getContratoDropDown();
    return response.itens;
  }
  async getProdutoServicoContratoDropDown(idContrato: number): Promise<DropDown[]> {
    return await this.service.getProdutoServicoContratoDropDown(idContrato);
  }

  async getRequisicaoCompraDropDown(
    filtrarAprovados: boolean,
  ): Promise<RequisicaoCompraDropDown[]> {
    const response = await this.service.getRequisicaoCompraDropDown({
      filtrarAprovados,
    });
    return response.itens;
  }

  async getAtributosCompra(
    telaId: number | null,
  ): Promise<AtributoCompra | null> {
    const response = await this.service.getAtributosCompra({
      telaId,
    });
    return response.item;
  }

  async getGruposAcessoDropDown(): Promise<DropDown[]> {
    const response = await this.service.getGruposAcessoDropDown();
    return response.itens;
  }

  async gedTornarObsoleto(
    idsArquivoDocumento: number[],
  ): Promise<void> {
    await this.service.gedTornarObsoletos({ idsArquivoDocumento });
  }

  async getGedArquivoData(
    idArquivoModulo: number,
  ): Promise<Blob> {
    const response = await this.service.getGedArquivoData({ idArquivoModulo });
    return response;
  }

  async getGedArquivoPdfData(
    idArquivoModulo: number,
  ): Promise<Blob> {
    const response = await this.service.getGedArquivoPdfData({ idArquivoModulo });
    return response;
  }
  async getProdutoServicoEsDropDown(IdControleEstoque: number): Promise<DropDown[]> {
    const response = await this.service.getProdutoServicoEsDropDown(IdControleEstoque);
    return response;
  }

  //#region Principal
  async getAllListagemDoc(
    Categoria: string,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<PrincipalDocumentosLista>> {
    const response = await this.service.getAllListagemDoc({
      Categoria,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map((item): PrincipalDocumentosLista => ({
        IdArquivoModulo: item.idArquivoModulo,
        Descricao: item.descricao,
        NomeArquivo: item.nomeArquivo,
      })
      ),
    };
  }
  //#endregion

  async saveUsuarioTableScheme(
    idUsuario: number,
    scheme: string,
  ): Promise<void> {
    await this.service.saveUsuarioTableScheme({ idUsuario, scheme });
  }
}
